/**
 * La session du back-office est celle de Firebase Auth dans ce navigateur.
 *
 * Le jeton n'est plus copie dans localStorage (audit, constat E6) : il y
 * etait lisible par n'importe quel script de la page. On le demande au SDK au
 * moment de l'appel — il le renouvelle lui-meme, et il vit dans un stockage
 * que le SDK gere.
 */
import { getAuth, onAuthStateChanged } from "firebase/auth";

/** Le jeton courant, ou null si personne n'est connecte. */
export async function jetonActuel() {
  const utilisateur = getAuth().currentUser;
  if (!utilisateur) return null;
  try {
    return await utilisateur.getIdToken();
  } catch {
    return null;
  }
}

/** Resout une fois l'utilisateur connecte (ou null), quand Firebase a tranche. */
export function utilisateurConnecte() {
  return new Promise((resolve) => {
    const arreter = onAuthStateChanged(getAuth(), (utilisateur) => {
      arreter();
      resolve(utilisateur);
    });
  });
}

/** Ce qu'on garde en local : le laboratoire et la structure, jamais un jeton. */
export function oublierSession() {
  // « sectionsAutorisees » part avec le reste : la personne suivante a se
  // connecter sur ce poste ne doit pas heriter du menu de la precedente.
  [
    "laboratory",
    "currentLab",
    "structure",
    "token",
    "username",
    "role",
    "sectionsAutorisees",
  ].forEach((cle) =>
    localStorage.removeItem(cle)
  );
}
